const getFeaturedArticles = (commonData, optionalTicker) => {
  if (optionalTicker) {
    if (
      commonData.allFeaturedOnCompanyLists.find(el => {
        return el.company.ticker === optionalTicker
      })
    ) {
      return commonData.allFeaturedOnCompanyLists.find(el => {
        return el.company.ticker === optionalTicker
      }).articles
    }
  }
  return commonData.featuredDefaultArticles
}

export default getFeaturedArticles
